import * as React from "react";
import {
  Dropdown,
  DropdownMenuItemType,
  IDropdownStyles,
  IDropdownOption,
} from "@fluentui/react/lib/Dropdown";
import { Card, Container, Stack, Row, Col } from "react-bootstrap";
import { TextField } from "@fluentui/react";
import { useEffect, useState, useRef } from "react";
import { PrimaryButton, DefaultButton } from "@fluentui/react/lib/Button";
import axios from "../configuration/axios";
import {
  Dialog,
  DialogType,
  DialogFooter,
  DialogContent,
} from "@fluentui/react/lib/Dialog";
import { Text } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";

const BuyLicensesComponent = (props) => {
  const modalPropsStyles = { main: { maxWidth: "50rem" } };
  const modalProps = React.useMemo(
    () => ({
      isBlocking: true,
      styles: modalPropsStyles,
      dragOptions: false,
    }),
    []
  );
  const dialogContentProps = {
    type: DialogType.normal,
    title: "Purchase additional licenses",
    subText:
      "This will allow you to buy additional licenses through the Microsoft AppSource Store.",
  };

  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
  const [licenseAmount, setLicenseAmount] = useState(0);
  const { subscriptionId, setTokenExpired } = props;

  const onLicenseAmountChange = (event, item) => {
    if (event.target.value < 0) {
      setLicenseAmount(0);
    } else {
      setLicenseAmount(event.target.value);
    }
  };

  async function purchaseLicenses() {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
      },
    };
    const bodyParameters = {
      subscriptionId: subscriptionId,
      quantity: parseInt(licenseAmount),
    };

    await axios
      .post(
        axios.defaults.baseURL + "/Subscription/AddLicenseQuantity",
        bodyParameters,
        config
      )
      .then((result) => {
        setTokenExpired(false);
        toggleHideDialog();
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setTokenExpired(true);
        }
      });
  }

  return (
    <Container>
      <Row>
        <Col style={{ width: "10rem", maxWidth: "10rem" }}>
          <TextField
            type="number"
            value={licenseAmount}
            label="Add licenses"
            onChange={onLicenseAmountChange}
          ></TextField>
        </Col>
        <Col style={{ marginTop: "1.65rem" }}>
          <PrimaryButton
            text="Purchase"
            onClick={toggleHideDialog}
          ></PrimaryButton>
        </Col>
      </Row>
      <Dialog
        hidden={hideDialog}
        onDismiss={toggleHideDialog}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}
      >
        <DialogContent>
          <Text>Are you sure you wish to purchase </Text>
          <Text>
            <b>{licenseAmount}</b> licenses? <br />
            Your purchase will be billed through Microsoft AppSource.
          </Text>
        </DialogContent>
        <DialogFooter>
          <PrimaryButton
          style={{  fontSize:"1.5vh" }}
            onClick={() => purchaseLicenses()}
            text="Confirm Purchase"
          />
          <DefaultButton style={{ fontSize:"1.5vh" }} onClick={toggleHideDialog} text="Cancel" />
        </DialogFooter>
      </Dialog>
    </Container>
  );
};

export default BuyLicensesComponent;
